<template>
    <div
        class="fixed inset-0 z-50 flex items-center justify-center p-5 transition-opacity duration-300"
        :class="[
            modelValue
                ? 'pointer-events-auto bg-[rgba(0,0,0,0.85)] opacity-100'
                : 'pointer-events-none bg-[rgba(0,0,0,0)] opacity-0',
        ]"
        @click.self="handleClose"
    >
        <div
            class="bg-card border-stroke-1 relative w-full border-1 shadow-lg"
            :class="[modelValue ? 'scale-100 opacity-100' : 'scale-90 opacity-0']"
        >
            <div
                class="absolute top-0 left-1/2 flex w-16 -translate-1/2 items-center bg-red-500 p-3"
                :class="success ? 'bg-green-500' : ''"
            >
                <svg
                    v-if="success"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M24.9423 11.6093L13.3328 23.2187L7.05664 16.9426L8.94226 15.0569L13.3328 19.4474L23.0566 9.72363L24.9423 11.6093Z"
                        fill="white"
                    />
                </svg>

                <svg
                    v-else
                    viewBox="0 0 32 32"
                    fill="none"
                    class="w-full"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20.0007 18.6663H22.6673M25.334 26.6663H26.6673M18.6673 22.6663V26.6663H21.334M22.6673 22.6663H26.6673V19.9997M5.33398 5.33301H13.334V13.333H5.33398V5.33301ZM5.33398 18.6663H13.334V26.6663H5.33398V18.6663ZM18.6673 5.33301H26.6673V13.333H18.6673V5.33301Z"
                        stroke="white"
                        stroke-width="2"
                    />
                </svg>
            </div>
            <button @click="handleClose" class="absolute top-5 right-5 z-10 text-5xl text-white">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.4141 11.9998L18.707 6.70684L17.2928 5.29263L11.9999 10.5856L6.70703 5.29273L5.29281 6.70694L10.5857 11.9998L5.2928 17.2928L6.70703 18.707L11.9999 13.414L17.2928 18.7069L18.707 17.2927L13.4141 11.9998Z"
                        fill="white"
                    />
                </svg>
            </button>
            <qrcode-vue
                :value="url"
                level="Q"
                class="h-[unset] w-full p-20 [&>svg]:h-[10vh] [&>svg]:w-full"
                render-as="svg"
                :size="1100"
            />
            <div
                class="border-stroke-1 w-full border-t-1 p-6 text-center text-3xl font-bold uppercase"
                :class="success ? 'text-green-500' : 'text-white'"
            >
                {{ success ? $t('share_qr.accepted') : $t('share_qr.scan_me') }}
            </div>
        </div>
    </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
    name: 'ShareQr',
    components: {
        QrcodeVue,
    },
    props: {
        url: {
            type: String,
            required: true,
        },
        success: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    methods: {
        handleClose() {
            this.$emit('update:modelValue', false)
        },
    },
}
</script>
